import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

const EmailButton = ({ email }) => {
  const { address, subject, message } = email;
  const handleClick = () => {
    const mailtoUrl = `mailto:${address}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(message)}`;
    window.location.href = mailtoUrl;
  };

  return (
    <button className="icon-button" onClick={handleClick}>
      <FontAwesomeIcon icon={faEnvelope} />
    </button>
  );
};

export default EmailButton;
